export default "__VITE_ASSET__08a532e6__"